import { render, staticRenderFns } from "./HeaderStatistics.vue?vue&type=template&id=d18b4dcc&scoped=true&"
import script from "./HeaderStatistics.vue?vue&type=script&lang=js&"
export * from "./HeaderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./HeaderStatistics.vue?vue&type=style&index=0&id=d18b4dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18b4dcc",
  null
  
)

export default component.exports